/** Official H-Plate social profiles. Keep these free of share-tracking query strings. */
export const FACEBOOK_URL = "https://www.facebook.com/profile.php?id=61596329393967";
export const INSTAGRAM_URL = "https://www.instagram.com/hplate.dm";
export const INSTAGRAM_HANDLE = "@hplate.dm";
